import axios from "axios";
import { treesActions } from "../../../../../store/slices/trees";
import { workerActions } from "../../../../../store/slices/workers";

const clonerHandlers = {
  getFiles: ":5107/files",
};

const cloner365Handlers = {
  getFiles: ":5111/remote/files",
};

const loadRepositoryNode = ({
  id,
  root,
  idx,
  server,
  M365server,
  tunnelToken: tunnel_token,
  path,
  c365ID,
}) => {
  return async (dispatch) => {
    let handlers;
    const is365device = !!c365ID;
    if (is365device) {
      handlers = cloner365Handlers;
    } else {
      handlers = clonerHandlers;
    }

    dispatch(workerActions.start(id));
    try {
      let url;
      if (is365device) {
        const base = M365server.split(":");
        url = base[0] + ":" + base[1] + handlers.getFiles;
      } else {
        url = server.slice(0, -1) + handlers.getFiles;
      }
      console.log("fetching node!");
      const response = await axios.get(url, {
        headers: { tunnel_token },
        params: { path: is365device?c365ID:encodeURIComponent(path) },
      });

      const children = response.data.children;

      for (const child of children) {
        dispatch(treesActions.addRSnode({ id: root, idx, node: child }));
      }

      dispatch(treesActions.RSnodeLoaded({ id: root, idx }));
      dispatch(workerActions.finish({ id }));
    } catch (e) {
      console.error(e);
      dispatch(workerActions.finish({ id, error: e.message }));
      return;
    }
  };
};

export default loadRepositoryNode;
